import React, { useEffect, useState } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import {Form, Row, Table, InputGroup} from 'react-bootstrap';
import './pdfitems.css';
import 'bootstrap/dist/css/bootstrap.min.css';
//import "bootstrap-icons/font/bootstrap-icons.css";
import {getData} from '../middleware/apiMiddleware';
import { useNavigate } from "react-router-dom";

import { ReactComponent as SearchSolid} from '../asset/search-solid.svg';


export default function Pdfitems() {
	const navigate = useNavigate();
	let [searchParams, setSearchParams] = useSearchParams();
	
	const [subject, setSubject] = useState();
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(50);
	const [pageOptions, setPageOptions] = useState([]);
	
	const [searchName, setSearchName] = useState("");
	const [searchId, setSearchId] = useState("");
	const [searchClassCode, setSearchClassCode] = useState("");
	
	const [state, setState] = useState({ 
		items: [],
		subject: '',
		subjects: [],
	});
	
	const fetchData = (myParam) => {		
		getData('item/listCourseItem?' + (new URLSearchParams(myParam)).toString(), navigate)
		.then(res => {			
			const subjectList = res.metadata.subjects.map((subjects) => subjects.subject);
			/*const subjectCntMap = res.metadata.subjects.reduce(function(map, obj) {
						map[obj.subject] = obj.cnt;
						return map;
				}, {});*/
				
			let maxPage =	res.metadata.maxPage;
			
			const po = [];
			for (let i = 1; i <= maxPage; i++) {
				po.push(i);
			}
			setPageOptions(po);			
			
			return setState({ items: res.data, subjects: subjectList, subject: myParam.subject });}
		);
	}
	
	useEffect(() => {
		let subject = searchParams.get("subject") || 'english';
		let page = searchParams.get("page") || '1';
		let limit = searchParams.get("limit") || '20';
		let searchId = searchParams.get("id") || '';
		let searchName = searchParams.get("name") || '';
		let searchClassCode = searchParams.get("classCode") || '';
		
		let myParam = {subject, page, limit};
		
		setSubject(subject);
		setPage(page);
		setLimit(limit);
		if (searchId.trim() !== "") {
			setSearchId(searchId);
			myParam['id'] = searchId;
		}
		if (searchName.trim() !== "") {
			setSearchName(searchName);
			myParam['name'] = searchName;
		}
		if (searchClassCode.trim() !== "") {
			setSearchName(searchClassCode);
			myParam['classCode'] = searchClassCode;
		}
		
		setSearchParams(myParam); 
		fetchData(myParam);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	
	const swapSubject = () => {
		let newSubject = 'english'
		if (subject === 'english') {
			newSubject = 'chinese';
		} else if (subject === 'chinese') {
			/*newSubject = 'math';
		} else {*/
			newSubject = 'english';
		}
		
		setSubject(newSubject);
		
		let myParam = { subject: newSubject, page, limit, };
		
		if (searchId.trim() !== "") { myParam['id'] = searchId; }
		if (searchName.trim() !== "") { myParam['name'] = searchName; }
		if (searchClassCode.trim() !== "") { myParam['classCode'] = searchClassCode; }
		
		setSearchParams(myParam); 
		fetchData(myParam);	
	}
	
	
	const resetParam = () => {
		
		let myParam = { subject, page, limit, };
		
		setSearchId('');
		setSearchName('');
		setSearchClassCode('');
		
		setSearchParams(myParam); 
		fetchData(myParam);	
	}
	
	
	const updatePage = (p) => {
		let subject = searchParams.get("subject") || 'english';
		let page = p;
		let limit = searchParams.get("limit") || '20';
		
		let myParam = {subject, page, limit};

		if (searchId.trim() !== "") { myParam['id'] = searchId; }
		if (searchName.trim() !== "") { myParam['name'] = searchName; }
		if (searchClassCode.trim() !== "") { myParam['classCode'] = searchClassCode; }
		
		setPage(page);
		setSearchParams(myParam); 
		fetchData(myParam);
	}
	
	const searchById = () => {
		if (searchId.trim() !== "") {
			setSearchId(searchId);
			setSearchName('');
			setSearchClassCode('');
			let myParam = {subject, page:1, limit, id:searchId};
			setSearchParams(myParam); 
			fetchData(myParam);	
		}
	}
	const searchByName = () => {
		if (searchName.trim() !== "") {
			setSearchId('');
			setSearchName(searchName);
			setSearchClassCode('');
			let myParam = {subject, page:1, limit, name:searchName};
			setSearchParams(myParam); 
			fetchData(myParam);	
		
		}
	}
	const searchByClassCode = () => {
		if (searchClassCode.trim() !== "") {
			setSearchId('');
			setSearchName('');
			setSearchClassCode(searchClassCode);
			let myParam = {subject, page:1, limit, classCode:searchClassCode};
			setSearchParams(myParam); 
			fetchData(myParam);	
		
		}
	}
	
	
	return (
		<div className="billContainer">
			
			<Row style={{marginTop:"100px"}} xs="auto">			
				{	state.subject !== '' && <div>
					<button onClick={swapSubject} className="billBtn billBtn-default" style={{ height:"100%", width:"80px"}}>{state.subject}</button>
				</div>}
				<div>
					<InputGroup style={{zIndex:"0 !important"}}>
						<div className="billBtn billBtn-default search-icon" onClick={searchById}>
							<SearchSolid className="search-icon-svg"/>
						</div>
						<Form.Control value={searchId}
							onChange={e => setSearchId(e.target.value)} 
							placeholder="Search by id"
							aria-label="Search by id"
							aria-describedby="basic-addon1"
						/>
					</InputGroup>
				</div>
				<div>
					<InputGroup>
						<div className="billBtn billBtn-default search-icon" onClick={searchByName}>
							<SearchSolid className="search-icon-svg"/>
						</div>
						<Form.Control value={searchName} 
							onChange={e => setSearchName(e.target.value)} 
							placeholder="Search by name"
							aria-label="Search by name"
							aria-describedby="basic-addon1"
						/>
					</InputGroup>
				</div>
				<div>
					<InputGroup>
						<div className="billBtn billBtn-default search-icon" onClick={searchByClassCode}>
							<SearchSolid className="search-icon-svg"/>
						</div>
						<Form.Control value={searchClassCode} 
							onChange={e => setSearchClassCode(e.target.value)} 
							placeholder="Search by class code"
							aria-label="Search by class code"
							aria-describedby="basic-addon1"
						/>
					</InputGroup>
				</div>
				<div><button onClick={resetParam} className="billBtn billBtn-default"   style={{ height:"100%", width:"80px"}}>Reset</button></div>
				


      </Row>
			<div style={{marginTop:"10px"}}>
				<div className="react-pagination-js-bootstrap">
            <ul>
							{pageOptions.map(p => (
									
								<li key={p} onClick={()=>updatePage(p)}  className="page">
									{p}
								</li>
									
								))
							}
            </ul>
         </div>
			</div>
			
			<div style={{marginTop:"10px"}}>
				<Table striped bordered hover>
					<thead>
						<tr>
							<th>#</th>
							<th>name</th>
							<th>Code</th>
							<th>Subject</th>
							<th colspan="3" style={{paddingRight:"0"}}><span style={{fontSize:"12px",margin:"0", padding:"0"}}>Action / PDF / Encoded</span></th>
						</tr>
					</thead>
					<tbody>
						{state.items.map(d => (
							<tr key={d.itemId}>
								<td>{d.itemId}</td>
								<td>{d.name}</td>
								<td>{d.classCode}</td>
								<td>{d.rcSubject}</td>
								<td>
									<Link to={`/pdfitem/${d.itemId}`}  className="billBtn billBtn-default">
										edit
									</Link>
								</td>
								<td>
									{(d.hasImgPath === 1) && (<i className="bi bi-check-circle" style={{ color:"#71BD6B"}}></i>)}
									{(d.hasImgPath === 0) && (<i className="bi bi-x-circle-fill"style={{ color:"#F23636"}}></i>)}
								</td>
								<td>
									{(d.hasPdf === 1) && (<i className="bi bi-check-circle" style={{ color:"#71BD6B"}}></i>)}
									{(d.hasPdf === 0) && (<i className="bi bi-x-circle-fill"style={{ color:"#F23636"}}></i>)}
								
								</td>
							</tr>))
						}
					</tbody>
				</Table>
			</div>
		</div>
  );
}